import * as React from 'react';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";
import DetalleVerBoton from './DetalleVerBoton';
import GoBackArrow from '../../../General/GoBackArrow';
import './DetalleLiquidacionEditar.css';

const TOTAL_TAB_GENERAL = 'general';
const TOTAL_TAB_NOTA_CREDITO = 'nota-credito';
const TOTAL_TAB_FACTURA = 'factura';

const FILAS_TOTAL_FACTURACION = [
    { campo: 'comisionNetaFacturacion', label: 'Comisión neta' },
    { campo: 'comisionTotalFacturacion', label: 'Comisión total a facturar' },
    { campo: 'totalCostoFeeNetoFacturacion', label: 'Costo fee neto' },
    { campo: 'totalCostoFeeFacturacion', label: 'Total costo fee con IVA' },
    { campo: 'totalRebateConIvaFacturacion', label: 'Total rebate con IVA' },
    { campo: 'totalNovedadesFacturacion', label: 'Novedades con IVA' },
    { campo: 'totalPercepcionFacturacion', label: 'Total percepciones' },
];

const FILAS_TOTAL_DEVOLUCION = [
    { campo: 'comisionNetaDevolucion', label: 'Comisión neta' },
    { campo: 'comisionTotalDevolucion', label: 'Comisión Nota de crédito' },
    { campo: 'totalCostoFeeNetoDevolucion', label: 'Costo fee neto' },
    { campo: 'totalCostoFeeDevolucion', label: 'Total costo fee con IVA' },
    { campo: 'totalRebateConIvaDevolucion', label: 'Total rebate con IVA' },
    { campo: 'totalNovedadesDevolucion', label: 'Novedades con IVA' },
    { campo: 'totalPercepcionDevolucion', label: 'Total percepciones' },
];

function pascalCase(camel) {
    return camel.charAt(0).toUpperCase() + camel.slice(1);
}

/** Variantes de nombre que puede devolver el API (p. ej. TotalAdevolver vs TotalADevolver). */
const LIQUIDACION_CAMPO_KEY_VARIANTS = {
    totalAdevolver: ['totalADevolver'],
    totalADevolver: ['totalAdevolver'],
};

function resolveLiquidacionCampoRaw(liquidacion, key) {
    const pascal = pascalCase(key);
    const sources = [liquidacion, liquidacion?.encabezadoLiquidacion].filter(Boolean);
    for (const src of sources) {
        const raw = src[key] ?? src[pascal];
        if (raw !== undefined && raw !== null && raw !== '') return raw;
    }
    return undefined;
}

export function getLiquidacionCampoNumerico(liquidacion, camelName) {
    if (!liquidacion || typeof liquidacion !== 'object') return 0;
    const keys = [camelName, ...(LIQUIDACION_CAMPO_KEY_VARIANTS[camelName] ?? [])];
    for (const key of keys) {
        const raw = resolveLiquidacionCampoRaw(liquidacion, key);
        if (raw === undefined) continue;
        const n = typeof raw === 'number' ? raw : Number(String(raw).replace(',', '.'));
        if (Number.isFinite(n)) return n;
    }
    return 0;
}

/** Total del tab Nota de crédito (ConsultarDetalleLiquidacion → totalAdevolver). */
export function getTotalNotaCredito(liquidacion) {
    return getLiquidacionCampoNumerico(liquidacion, 'totalAdevolver');
}

export function getTotalFactura(liquidacion) {
    return getLiquidacionCampoNumerico(liquidacion, 'totalFacturar');
}

export function getLiquidacionCampoTexto(liquidacion, camelName) {
    if (!liquidacion || typeof liquidacion !== 'object') return '';
    const pascal = pascalCase(camelName);
    const raw =
        liquidacion[camelName] ??
        liquidacion[pascal] ??
        liquidacion.encabezadoLiquidacion?.[camelName] ??
        liquidacion.encabezadoLiquidacion?.[pascal];
    if (raw == null) return '';
    return String(raw).trim();
}

function debeMostrarTabTotalNotaCredito(liquidacion) {
    return getTotalNotaCredito(liquidacion) !== 0;
}

function debeMostrarTabTotalFactura(liquidacion) {
    return getTotalFactura(liquidacion) !== 0;
}

export default class DetalleLiquidacionEditar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeTotalTab: TOTAL_TAB_GENERAL };
    }

    componentDidUpdate(prevProps) {
        const { liquidacion } = this.props;
        if (prevProps.liquidacion !== liquidacion) {
            const mostrarNc = debeMostrarTabTotalNotaCredito(liquidacion);
            const mostrarFactura = debeMostrarTabTotalFactura(liquidacion);
            if (
                (!mostrarNc && this.state.activeTotalTab === TOTAL_TAB_NOTA_CREDITO) ||
                (!mostrarFactura && this.state.activeTotalTab === TOTAL_TAB_FACTURA)
            ) {
                this.setState({ activeTotalTab: TOTAL_TAB_GENERAL });
            }
        }
    }

    render = () => {
        const { liquidacion, isBorrador } = this.props;
        const mostrarTabNotaCredito = debeMostrarTabTotalNotaCredito(liquidacion);
        const mostrarTabFactura = debeMostrarTabTotalFactura(liquidacion);

        const totalTabs = [
            { key: TOTAL_TAB_GENERAL, label: 'Total general', modifier: 'general' },
            ...(mostrarTabNotaCredito ? [{ key: TOTAL_TAB_NOTA_CREDITO, label: 'Total nota de crédito', modifier: 'nota-credito' }] : []),
            ...(mostrarTabFactura ? [{ key: TOTAL_TAB_FACTURA, label: 'Total factura', modifier: 'factura' }] : []),
        ];

        return (
            <>
                <div
                    className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading liquidacion-detalle-page-heading"
                    style={{
                        background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)',
                        borderLeft: '4px solid var(--rojo-megatone, #c00)',
                    }}
                >
                    <div className="col-12 d-flex flex-wrap align-items-center gap-3">
                        {this.props.onVolver !== false && (
                            <GoBackArrow onBack={this.props.onVolver} label="Volver" />
                        )}
                        <div className="flex-grow-1 min-w-0">
                            <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">
                                {isBorrador ? 'Liquidación en borrador' : 'Detalle de liquidación'}
                            </h4>
                            <p className="mb-0 mt-1 small text-muted">
                                {isBorrador
                                    ? 'Revisión, cálculo de tributos y confirmación de la liquidación.'
                                    : 'Consulta de totales, órdenes, novedades y comprobantes asociados.'}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row g-3 liquidacion-detalle-layout">
                    <div className="col-12 col-sm-6">
                        <div className="liquidacion-detalle-info-card">
                            <div className="liquidacion-detalle-badges">
                                <span
                                    className={`liquidacion-detalle-badge ${
                                        liquidacion.cantidadOrdenes === 0
                                            ? 'liquidacion-detalle-badge--ordenes-empty'
                                            : 'liquidacion-detalle-badge--ordenes-active'
                                    }`}
                                >
                                    <span className="liquidacion-detalle-badge__count">{liquidacion.cantidadOrdenes}</span>
                                    {liquidacion.cantidadOrdenes === 1 ? 'Orden' : 'Órdenes'}
                                </span>
                                <span
                                    className={`liquidacion-detalle-badge ${
                                        liquidacion.cantidadNovedades === 0
                                            ? 'liquidacion-detalle-badge--novedades-empty'
                                            : 'liquidacion-detalle-badge--novedades-active'
                                    }`}
                                >
                                    <span className="liquidacion-detalle-badge__count">{liquidacion.cantidadNovedades}</span>
                                    {liquidacion.cantidadNovedades === 1 ? 'Novedad' : 'Novedades'}
                                </span>
                                {liquidacion.idTipoEstadoLiquidacion === 3 && (
                                    <span className="liquidacion-detalle-badge liquidacion-detalle-badge--confirmada">
                                        <i className="fa fa-check-circle" aria-hidden="true" />
                                        Liquidación Confirmada
                                    </span>
                                )}
                            </div>
                            <div className="liquidacion-detalle-meta">
                                <div className="liquidacion-detalle-meta__row">
                                    <span className="liquidacion-detalle-meta__icon" aria-hidden="true">
                                        <i className="fa fa-hashtag" />
                                    </span>
                                    <div>
                                        <span className="liquidacion-detalle-meta__label">N° Liquidación</span>
                                        <span className="liquidacion-detalle-meta__value">{liquidacion.idLiquidacion}</span>
                                    </div>
                                </div>
                                <div className="liquidacion-detalle-meta__row">
                                    <span className="liquidacion-detalle-meta__icon" aria-hidden="true">
                                        <i className="fa fa-building" />
                                    </span>
                                    <div>
                                        <span className="liquidacion-detalle-meta__label">Seller</span>
                                        <span className="liquidacion-detalle-meta__value">{liquidacion.razonSocialSeller}</span>
                                    </div>
                                </div>
                                <div className="liquidacion-detalle-meta__row">
                                    <span className="liquidacion-detalle-meta__icon" aria-hidden="true">
                                        <i className="fa fa-calendar" />
                                    </span>
                                    <div>
                                        <span className="liquidacion-detalle-meta__label">Fecha</span>
                                        <span className="liquidacion-detalle-meta__value">{liquidacion.mostrarFecha}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {isBorrador && liquidacion.idTipoEstadoLiquidacion !== 3 && (
                            <div
                                className="alert alert-warning d-flex align-items-center mt-3 liquidacion-detalle-alert-borrador border-0"
                                role="alert"
                            >
                                <i className="fa fa-exclamation-circle me-2" style={{ fontSize: '1.2rem' }} />
                                <div>
                                    <strong>Atención:</strong> Liquidación pendiente de confirmar
                                </div>
                            </div>
                        )}

                        {this.props.children}
                    </div>

                    <div className="col-12 col-sm-6">
                        <div className="liquidacion-detalle-totales-card">
                            <div className="liquidacion-detalle-totales-tabs" role="tablist">
                                {totalTabs.map(tab => (
                                    <button
                                        key={tab.key}
                                        type="button"
                                        role="tab"
                                        aria-selected={this.state.activeTotalTab === tab.key}
                                        className={`liquidacion-detalle-totales-tab liquidacion-detalle-totales-tab--${tab.modifier} ${
                                            this.state.activeTotalTab === tab.key
                                                ? `liquidacion-detalle-totales-tab--active liquidacion-detalle-totales-tab--${tab.modifier}`
                                                : ''
                                        }`}
                                        onClick={() => this.setState({ activeTotalTab: tab.key })}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                            </div>

                            <div className="liquidacion-detalle-totales-body">
                                {this.state.activeTotalTab === TOTAL_TAB_GENERAL && (
                                    <>
                                        <DetailItem label="Total Ordenes" value={liquidacion.totalOrden} />
                                        <DetailItem label="Comision Neta" value={liquidacion.comisionNeta} />
                                        <DetailItem label="Costo Fee Neto" value={liquidacion.totalCostoFeeNeto} />
                                        <DetailItem label="Total Costo Fee Con Iva" value={liquidacion.totalCostoFee} />
                                        <DetailItem label="Novedades Con Iva" value={liquidacion.totalNovedades} />
                                        <DetailItem label="Total Rebate Con Iva" value={liquidacion.totalRebateConIva} />
                                        <DetailItem label="Total Retenciones" value={liquidacion.totalRetenciones} />
                                        <DetailItem
                                            label="Total Percepciones"
                                            value={liquidacion.totalPercepcion}
                                            onVerDetalle={
                                                liquidacion.totalPercepcion > 0 && this.props.onVerDetallePercepciones
                                                    ? () =>
                                                          this.props.onVerDetallePercepciones(
                                                              this.props.liquidacion.idLiquidacion,
                                                              'liquidacion'
                                                          )
                                                    : null
                                            }
                                        />
                                        <DetailItem
                                            label="Total liquidacion"
                                            value={liquidacion.totalLiquidacion}
                                            highlight
                                            variant="general"
                                        />
                                    </>
                                )}

                                {this.state.activeTotalTab === TOTAL_TAB_NOTA_CREDITO && mostrarTabNotaCredito && (
                                    <>
                                        {FILAS_TOTAL_DEVOLUCION.map(({ campo, label }) => (
                                            <DetailItem
                                                key={campo}
                                                label={label}
                                                value={getLiquidacionCampoNumerico(liquidacion, campo)}
                                            />
                                        ))}
                                        <DetailItem
                                            label="Total Nota de Credito"
                                            value={getTotalNotaCredito(liquidacion)}
                                            highlight
                                            variant="nota-credito"
                                        />
                                    </>
                                )}

                                {this.state.activeTotalTab === TOTAL_TAB_FACTURA && mostrarTabFactura && (
                                    <>
                                        {FILAS_TOTAL_FACTURACION.map(({ campo, label }) => (
                                            <DetailItem
                                                key={campo}
                                                label={label}
                                                value={getLiquidacionCampoNumerico(liquidacion, campo)}
                                            />
                                        ))}
                                        <DetailItem
                                            label="Total Factura"
                                            value={liquidacion.totalFacturar}
                                            highlight
                                            variant="factura"
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function DetailItem({ label, value, highlight = false, variant = 'general', onVerDetalle = null }) {
    const formatValue = `$${formatoDecimal(value)}`;
    const rowClass = [
        'liquidacion-detalle-total-row',
        highlight && 'liquidacion-detalle-total-row--highlight',
        highlight && variant && `liquidacion-detalle-total-row--${variant}`,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={rowClass}>
            <span className="liquidacion-detalle-total-row__label">{label}</span>
            <span
                className={`liquidacion-detalle-total-row__value${onVerDetalle ? ' liquidacion-detalle-total-row__value--link' : ''}`}
            >
                {formatValue}
                {onVerDetalle && (
                    <DetalleVerBoton onClick={onVerDetalle} title={`Ver detalle de ${label}`} />
                )}
            </span>
        </div>
    );
}
